import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const ContainerForm = styled.div`
  padding: 1.5rem 2.5rem;
  max-width: 30rem;

  button {
    margin-top: 2rem;
  }
`;
